import * as React from "react";
import { Edit, SimpleForm, TextInput, required, SelectInput } from 'react-admin';
import { RichTextInput } from "ra-input-rich-text";
import { CustomRichTextInputToolbar, MyEditorOptions } from "../../Components/CustomRichText/CustomRichTextInput";
import { LegalPapersTags } from "./LegalPapersUtils";

export const LegalPaperEdit = (props) => (
    <Edit {...props}>
        <SimpleForm redirect="list">
            <TextInput disabled label="Identifiant" source="id" />
            <TextInput label="Titre" source="title" validate={required()} fullWidth/>
            <SelectInput source="tag" validate={required()} choices={LegalPapersTags} />
            <SelectInput source="locale" validate={required()} choices={[
                { id: 'de', name: 'Allemand' },
                { id: 'en', name: 'Anglais' },
                { id: 'es', name: 'Espagnol' },
                { id: 'fr', name: 'Français' },
                { id: 'hi', name: 'Indien' },
                { id: 'pt', name: 'Portugais' },
                { id: 'pt-br', name: 'Portugais brésilien' },
            ]} />
            <RichTextInput editorOptions={MyEditorOptions} toolbar={<CustomRichTextInputToolbar />} source="content" />
        </SimpleForm>
    </Edit>
);